import React, { useEffect, useRef, useState } from 'react'

import axios from "axios";
import auth from '../../Helpers/auth'

//iconos
import menu from '../../assets/icons/menu.svg'
import menu_azul from '../../assets/icons/menu_azul.svg'
import notification_star from '../../assets/icons/notification-star.svg'
import * as constants from '../../global/const'
import MenuComponent from './menuCabezote.component'
import CardOpciones from './cardOpciones.component'
import IconNotificacion from "../../assets/icons/notificaciones.svg";
// import CardCarrito from '../../Components/Carrito/cardCarrito.component'
import ModalNotificacion from '../../Components/Cabezote/Notificacion/modalNotificacion.component'

//components
import SucursalComponent from '../Sucursal/sucursal.component'
import ProgressButton from '../ProgressButton/progressButton.component'
import { useHistory } from 'react-router-dom'
import { Buscador } from './Buscador/buscador.component'
import { Alerta } from './alerta.component'

//imagenes
// import noimage from '../../assets/images/postobon.png'
import search from '../../assets/icons/search-light.svg'
import searchSolid from '../../assets/icons/search-solid.svg'
import surcursal_light from '../../assets/icons/sucursal.svg'
import surcursal_solid from '../../assets/icons/sucursal-solid.svg'
import { useDispatch, useSelector } from 'react-redux';
import CardNotificaciones from './Notificacion/cardNotificaciones.component';
import { setCarrito } from '../../Redux/actions/CarritoAction';
import { setCarritoPromos } from '../../Redux/actions/CarritoPromoAction';
import { CabezoteBajo } from './cabezoteBajo.component';
import { useWindowDimensions } from '../../Helpers/useWindowDimensions';

//WhatssApp
import WhatsappComponent from '../Whatsapp/whatsapp.component';


const CabezoteComponent = (props) => {
    const sucursal = useSelector(state => state.page.sucursal);
    let user = JSON.parse(auth.getUsuario());
    let _carrito = JSON.parse(localStorage.getItem(constants.CARRITO)) || {};
    let _carritoPromos = JSON.parse(localStorage.getItem(constants.CARRITOPROMO)) || {};

    const dispatch = useDispatch();
    const dispatchPromo = useDispatch();
    const AgregarCarrito = carrito => dispatch(setCarrito(carrito));
    const AgregarCarritoPromos = carritoPromos => dispatchPromo(setCarritoPromos(carritoPromos));
  
    const [imagenUrl, setImagenUrl ] = useState(`${constants.URL_BASE_IMAGES}/MenuCabezote/1.png?${Math.random()}`);
    // AgregarCarrito(_carrito);

    const [notifications, setNotifications] = useState([]);
    const [listNotifications, setListNotifications] = useState([]);
    const [notificacion, setNotificacion] = useState("");
    // let counter = 0;
    const [showMessage, setShowMessage] = useState(false);
    const [message, setMessage] = useState("");
    const [expandedGlobal, setExpandedGlobal] = React.useState(false);
    //const [close, setclose] = useState(true)
    // const [searchGlobal, setSearchGlobal] = useState(false);
    const { open, setOpen, tipo, close, setclose, categoriasGlobal, tipoCamino = 0, mostrarOpciones, setMostrarOpciones } = props;
    const myRef = useRef();
    const [show, setShow] = useState(false);
    const [carAlert, setCarAlert] = useState(false);
    const [carState, setCarState] = useState(false);
    const [isResponsive, setIsResponsive] = useState(false);
    const [handleResize] = useWindowDimensions(isResponsive, setIsResponsive, 600);

    const handleClickOutside = (event) => {
        //Caso que se tiene en cuenta para que no lo ubique como falso
        const array = event.path || (event.composedPath && event.composedPath());
        const auxSucursal = array.filter(
            p => (
                p.className == "icon-search icon_user activar" ||
                p.className == "select-sucursales select-css activar"
            )
        ).length > 0;
        if (
            myRef.current &&
            !myRef.current.contains(event.target) &&
            event.target.className.indexOf &&
            !auxSucursal
        ) {
            if (event.target.innerText === "Cambiar dirección") {
                setclose(false);
            }
            else {
                setclose(true);
            }

        }
    };
    const getNotificaciones = () => {
        axios.get(constants.NOTIFICACIONES + `?correo=${user.email}&nit=${user.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}`).then((response) => {
            setListNotifications(response.data)
            console.log(response.data)
            setNotificacion(response.data.find(n => n.marcacion === 0))

        }).catch((err) => {
            console.log("error ", err);
        })
    }

    const marcacionNotificacion = (idNotificacion) => {

        axios.post(
            constants.MARCACIONOTIFICACIONES, { correo: user.email, nit: user.nit, codigo: sucursal.codigo, agencia: sucursal.agencia, notificacionId: idNotificacion }
        )
            .then(
                (response) => {
                    getNotificaciones()
                }
            ).catch(
                (err) => {
                    console.log(err);
                }
            )
    }
    const getNovedadPedidos = async () => {

        await axios.get(
            constants.NOVEDADPEDIDO + `?clienteUsuarioId=${user.id}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&nit=${sucursal.nit}&correo=${user.email}`
        )
            .then(
                (response) => {
                    setNotifications(response.data)
                }
            ).catch(
                (err) => {
                    console.log(err);
                }
            )
    }


    useEffect(() => {
        if (sucursal) {
            getNovedadPedidos();
            getNotificaciones();
        }

    }, [sucursal])

    useEffect(() => {
        AgregarCarrito(_carrito);
        AgregarCarritoPromos(_carritoPromos);
        handleResize();

        window.addEventListener('resize', handleResize, true);
        document.addEventListener('click', handleClickOutside, true)
        // document.addEventListener('scroll', handleScrollHead, true)
        return () => {
            window.removeEventListener('resize', handleResize, true)
            document.removeEventListener('click', handleClickOutside, true);
            // document.removeEventListener('scroll', handleScrollHead, true)
        };

    }, [])

    let history = useHistory();

    const handleMenuOptions = (e) => {
        setMostrarOpciones(!mostrarOpciones);
    }



    // const handleManagement = () => {       
    //     axios.get('https://apimgmprbs.azure-api.net/celu_vrcw_b2bc/get/users', {headers : {
    //         Authorization: `Bearer ${auth.getToken()}`,
    //         'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBCRIPTION_KEY
    //     }}).then((response)=>{
    //     }).catch((err)=>{
    //         console.log(err)
    //     })
    // }

    // useEffect(() => {

    // }, [])

    return (
        <>
            {
                <div className="header box cabezote">
                    {/* {
                                    close, open, show, carAlert, mostrarOpciones, carState
                                )
                            } */}
                    {
                        (
                            close == false ||
                            open ||
                            show ||
                            carAlert ||
                            mostrarOpciones ||
                            carState
                        )
                        &&
                        <div className="background principal">
                        </div>
                    }
                    <div className="logo_menu">
                        {

                            notificacion &&
                                notificacion.marcacion === 0?
                                <>
                                    <ModalNotificacion
                                        setShowModal={
                                            () => {
                                                sucursal && marcacionNotificacion(notificacion.id)
                                            }
                                        }
                                        notificacionSelect={notificacion}
                                        img={`${constants.URL_BASE_IMAGES}Notificaciones/${notificacion.id}.png`}
                                    />
                                </>
                                : null
                        }
                        <MenuComponent open={open} setOpen={setOpen} setExpandedGlobal={setExpandedGlobal} />
                        <img src={menu_azul} className="icon_menu" onClick={() => { setOpen(!open) }} />
                        <div className="inicio-menu" onClick={() => { setOpen(!open) }}>
                            <p ><b>Menú</b></p>
                        </div>
                        <div
                            className={"notificacion-content activarCampana " + ((listNotifications.length > 0 || notifications.length > 0) && "show")}
                            role="button"
                            onClick={
                                () => {
                                    if (listNotifications.length > 0 || notifications.length > 0) {
                                        setCarAlert(!carAlert);
                                        setShowMessage(true);
                                    }
                                }
                            }
                        >
                            <img
                                className="notificacion width_icon_cabezote activarCampana"
                                src={IconNotificacion}
                                alt=""
                                style={{ cursor: "pointer" }}
                                onClick={
                                    () => {
                                        if (listNotifications.length > 0) {
                                            setShowMessage(true);
                                            if (notifications.length > 0) {
                                                setMessage(`Novedades en el pedido , ${notifications[0].orden}`);
                                            }
                                        }
                                    }
                                }
                            />
                            <img className="notificacion-content-star" src={notification_star} />
                        </div>
                        <div className="logo-p">
                            <img src={imagenUrl} onClick={e => window.location.href = ("./inicio")}/>
                        </div>

                        <div
                            className="select-css aux"
                            style={{ justifyContent: "space-between" }}
                            onClick={handleMenuOptions}
                        >
                            <p style={{ margin: "0" }}>Productos</p>
                        </div>
                        {
                            (!isResponsive)
                                ?
                                <CardOpciones
                                    mostrarOpciones={mostrarOpciones}
                                    setMostrarOpciones={setMostrarOpciones}
                                    history={history}
                                    categoriasGlobal={categoriasGlobal}
                                    tipoCamino={tipoCamino}
                                />
                                :
                                <></>
                        }
                    </div>

                    <Buscador history={history} setShow={setShow} show={show} />


                    <div className="align">
                        <div className="icon-search" onClick={() => setShow(!show)}>
                            {
                                show ?
                                    <img src={searchSolid} alt="" /> : <img src={search} alt="" />
                            }
                        </div>
                        <div
                            className="icon-search icon_user activar"
                            onClick={() => setclose(!close)}
                        >
                            {
                                close
                                    ?
                                    <img
                                        src={surcursal_light}
                                        loading="lazy"
                                        className="width_icon_cabezote"
                                        alt=""
                                    />
                                    :
                                    <img
                                        loading="lazy"
                                        src={surcursal_solid}
                                        alt=""
                                    />
                            }
                        </div>

                        <div className="sucursales activar" style={{ position: "relative" }}>
                            <SucursalComponent myRef={myRef} close={close} setclose={setclose} />
                        </div>
                        {/* <SucursalComponent /> */}

                        <ProgressButton
                            myRef={myRef}
                            history={history}
                            width={100}
                            percent={2}
                            setCarState={setCarState}
                            carState={carState}
                        />
                    </div>

                    {
                        (sucursal && showMessage)
                        &&
                        <CardNotificaciones
                            setCarAlert={setCarAlert}
                            showMessage={showMessage}
                            carAlert={carAlert}
                            myRef={myRef}
                            message={message}
                            notifications={notifications}
                        />
                        /** 
                        <Alerta
                        history={history}
                        mensaje={message}
                        show={showMessage}
                        setShow={setShowMessage}
                        tipo={1}
                    />*/

                    }
              <WhatsappComponent />  
                </div>
            }
            {
                isResponsive
                &&
                < CabezoteBajo
                    close={close}
                    categoriasGlobal={categoriasGlobal}
                    history={history}
                    open={open}
                    setOpen={setOpen}
                    setclose={setclose}
                    mostrarOpciones={mostrarOpciones}
                    handleMenuOptions={handleMenuOptions}
                    setMostrarOpciones={setMostrarOpciones}
                />
            }
        </>
    )
}

export default CabezoteComponent;